// material-ui
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { FormattedMessage } from "react-intl";
import React from "react";
import { WarningTwoTone } from "@mui/icons-material";

// ==============================|| COMPONENTS - MODAL ACTION ||============================== //

interface Props {
    open: boolean;
    checkResult: any;
    handleClose: () => void;
    handleAction?: any;
}

const ModalWarningActivity = ({ open, checkResult, handleClose, handleAction }: Props) => {

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            keepMounted
            aria-labelledby="item-delete-title"
            aria-describedby="item-delete-description"
        >
            {open && (
                <>
                    <DialogTitle id="item-delete-title">Attenzione!</DialogTitle>
                    <DialogContent>
                        <p>
                            Alcuni dati da te inseriti necessitano di intervento manuale. Per continuare accetta le
                            seguenti
                            condizioni:
                        </p>
                        {
                            checkResult.result.teacher_is_busy && (
                                <p>
                                    <WarningTwoTone /><span style={{ marginLeft: '8px' }}>L'insegnante è occupato per gli orari specificati</span>
                                </p>
                            )
                        }
                        {
                            !checkResult.result.platfond_is_enough && (
                                <p>
                                    <WarningTwoTone /><span style={{ marginLeft: '8px' }}>Il platfond non è sufficiente a coprire il costo della lezione</span>
                                </p>
                            )
                        }
                        {
                            !checkResult.result.teacher_ratio_is_ok && (
                                <p>
                                    <WarningTwoTone /><span style={{ marginLeft: '8px' }}>Il rateo dell'insegnante è stato superato</span>
                                </p>
                            )
                        }
                    </DialogContent>
                    <DialogActions sx={{ mr: 2 }}>
                        <Button onClick={handleClose} color="error">
                            <FormattedMessage id={'SYS00003'} />
                        </Button>
                        <Button variant="contained" size="small" onClick={handleAction} autoFocus>
                            Sì voglio procedere all'inserimento
                        </Button>
                    </DialogActions>
                </>
            )}
        </Dialog>
    );
};

export default ModalWarningActivity;